import {Box, HBox} from '@buncha/components/core/view';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import Boxes from '@buncha/components/core/icon/Boxes';
import {BuyerData} from '@buncha/itemDetails/types/ItemScanner';
import {H6Text} from '@buncha/components/core/text';
import HourGlass from '@buncha/components/core/icon/HourGlass';
import If from '@buncha/components/conditional/If';
import ItemName from '@buncha/batchDetails/component/ItemName';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import UpdateDetailsSection from '../updateDetailsSection';
import UpdatePriceCarousal from '@buncha/components/composites/Carousal/UpdatePriceCarousal';
import font from '@buncha/appStyles/style/font';
import {styles} from './style';
import {useGetLocale} from '@buncha/localization/hooks';
import {useItemScannerContext} from '@buncha/itemDetails/hooks/ItemScanner';

const DetailsInput = () => {
  const {state} = useItemScannerContext();
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const buyerData = state.buyerData;
  const {body} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const getDetailsCell = useCallback((item: BuyerData) => {
    return <UpdateDetailsSection item={item} />;
  }, []);

  const getCarouselCell = useCallback(
    (item: BuyerData) => {
      const quantity = item?.updatedQuantity || item?.quantity || 0;
      return (
        <Box style={styles.itemContainerBox}>
          <HBox style={styles.detailsContainer}>
            <HBox>
              {/* <ProfileIcon viewBox="-3 -1 25 25" fill={theme?.text.blue[300]} /> */}
              <Box style={styles.marRig10}>
                <ItemName
                  name={`${item.firstName} ${item.lastName || ''}`}
                  size={font.FontSize.fontH3.fontSize}
                  nameStyle={{fontFamily: muliFont[900].normal}}
                />
              </Box>
              <HourGlass
                fill={theme?.background.blue[300]}
                height={20}
                width={20}
                viewBox="0 -7 15 25"
              />
            </HBox>
            <HBox>
              <Boxes width="20" height="20" viewBox="0 0 15 15" fill="none" />
              <H6Text
                style={[
                  styles.remainingQuantity,
                  {color: theme?.text.orange[100]},
                ]}>
                {body?.quantityForThisUser?.replace('{quantity}', quantity)}
              </H6Text>
            </HBox>
          </HBox>
          <Box>{getDetailsCell(item)}</Box>
        </Box>
      );
    },
    [
      body?.quantityForThisUser,
      getDetailsCell,
      muliFont,
      theme?.background.blue,
      theme?.text.orange,
    ],
  );

  return (
    <React.Fragment>
      <If condition={buyerData?.length === 1}>
        {getDetailsCell(buyerData[0])}
      </If>
      <If condition={buyerData?.length > 1}>
        <UpdatePriceCarousal
          paginationSize={8}
          containerStyle={styles.itemContent}
          imageContainerStyle={styles.itemImage}
          showImageCaption={true}
          imageCaption={''}
          data={buyerData}
          disabledPaginationColor={theme?.text.gray[300]}
          showPagination={true}
          renderItem={getCarouselCell}
          nextButton
        />
      </If>
    </React.Fragment>
  );
};

export default React.memo(DetailsInput);
